import type { Token, TokenType } from './token';

type Context = {
  input: string;
  failedToken?: Token;
  expectedTokenType?: TokenType;
  previousToken?: Token;
};

export class ParserError extends Error {
  name = 'ParserError';
  failedToken?: Token;
  expectedType?: TokenType;
  context?: Context;

  constructor(message: string, context?: Context) {
    super(message);
    this.message = message;
    this.context = context;
  }
}

export class SyntaxError extends ParserError {
  name = 'SyntaxError';
}
